import React, { createContext, useContext, useReducer } from 'react';

const initialState = {
  taskId: null,
  analysisResult: null,
  parts: [],               // 多零件数据，每个元素: { cadFile, imgFiles, taskId, status, result, material, quantity, surfaceTreatments, toleranceGrade, roughnessRa }
  quotes: [],              // 批量报价结果，每个元素: { ...part, quoteResult }
  material: null,          // 单零件时使用的物料（保留兼容）
  quantity: 1,
  surfaceTreatments: [],
  toleranceGrade: '未标注/自由公差',
  roughnessRa: 3.2,
  quoteResult: null,
  loading: false,
};

function quoteReducer(state, action) {
  switch (action.type) {
    case 'SET_TASK':
      return { ...state, taskId: action.payload };
    case 'SET_ANALYSIS_RESULT':
      return { ...state, analysisResult: action.payload };
    case 'SET_PARTS':
      return { ...state, parts: action.payload };
    case 'SET_QUOTES':
      return { ...state, quotes: action.payload };
    case 'SET_MATERIAL':
      return { ...state, material: action.payload };
    case 'SET_QUANTITY':
      return { ...state, quantity: action.payload };
    case 'SET_SURFACE_TREATMENTS':
      return { ...state, surfaceTreatments: action.payload };
    case 'SET_TOLERANCE_GRADE':
      return { ...state, toleranceGrade: action.payload };
    case 'SET_ROUGHNESS_RA':
      return { ...state, roughnessRa: action.payload };
    case 'SET_QUOTE_RESULT':
      return { ...state, quoteResult: action.payload };
    case 'SET_QUOTES':
      return { ...state, quotes: action.payload };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

const QuoteContext = createContext();

export const QuoteProvider = ({ children }) => {
  const [state, dispatch] = useReducer(quoteReducer, initialState);

  return (
    <QuoteContext.Provider value={{ state, dispatch }}>
      {children}
    </QuoteContext.Provider>
  );
};

export const useQuote = () => useContext(QuoteContext);
